module.exports = __webpack_public_path__ + "static/media/CardViewArrow.60ea5f23.svg";